<template>
  <div class="hotelSectionInner">
    <h2 class="hotelH2">クチコミ</h2>
    <tk-link
      v-if="moreCommentHeaderText"
      class="hotelBtnH2"
      @click="$emit('view-more')"
    >
      {{ moreCommentHeaderText }}
    </tk-link>

    <tk-hotel-review-common :average-rating="averageRating" />
    <tk-hotel-review-list :reviews="reviews" />

    <div v-if="showLoadMoreButton" class="hotelCommentMore">
      <slot name="moreComment"></slot>

      <tk-link @click="$emit('view-more')">
        <tk-svg-icon icon="plus" class="icoPlus" />
        {{ moreCommentText }}
      </tk-link>
    </div>
  </div>
</template>

<script>
import { TkLink, TkSvgIcon } from '@ota-frontend/ui'
import TkHotelReviewCommon from './TkHotelReviewCommon.vue'
import TkHotelReviewList from './TkHotelReviewList.vue'

export default {
  name: 'TkHotelReview',
  components: {
    TkHotelReviewCommon,
    TkHotelReviewList,
    TkLink,
    TkSvgIcon,
  },
  props: {
    reviews: { type: Array, default: () => [] },
    moreCommentText: { type: String, default: 'すべてのクチコミをみる' },
    moreCommentHeaderText: { type: String, default: null },
    averageRating: { type: String, default: '0.0' },
    showLoadMoreButton: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
@import '~@ota-frontend/ui/src/scss/components/TkHotelReview.scss';
</style>
